import { lazy } from 'react';

const PageCreatorListPage = lazy(() => import('./pages/list'));
const PageCreatorCreatePage = lazy(() => import('./pages/create'));
const PageCreatorEditPage = lazy(() => import('./pages/edit'));

const PageCreatorSettingsPage = lazy(() => import('./pages/settings'));

export const pageCreatorRoutes = {
    path: 'pages',
    children: [
        { element: <PageCreatorListPage />, index: true },
        { path: 'new', element: <PageCreatorCreatePage /> },
        { path: ':id/edit', element: <PageCreatorEditPage /> },
        { path: ':id/settings', element: <PageCreatorSettingsPage /> },
    ],
};
